module.exports = __webpack_public_path__ + "static/media/HomeOrders.98cc60ee.svg";